export const MIN_DATE_STRING = '2020-01-01'
export const MAX_EXTRA_YEARS = 10
